import { TranslatedString } from "@pg-flex/shared-js/utils/i18n";
import { ComponentProps, FC, useEffect } from "react";
import { styled, css } from "styled-components";

import { isStaging } from "@/valor-utils/isEnv";

interface StyledProps {
  $fullWidth?: boolean;
}

const Styles = styled.div.attrs({
  className: "screen-container",
})<StyledProps>`
  flex: 1; // Fill parent width
  padding-left: var(--app-sidebar-gap);
  overflow: auto;
  /* some space after the content */
  padding-bottom: 24px;
  /* App max-width */
  ${(props) =>
    props.$fullWidth
      ? css`
          padding-right: var(--app-horizontal-space);
          margin-right: calc(0px - var(--app-horizontal-space));
        `
      : css`
          max-width: calc(
            var(--screen-container-width) - var(--app-horizontal-space)
          );
        `}
`;

type Props = Omit<ComponentProps<typeof Styles>, "$fullWidth" | "title"> & {
  // We need to expose $fullWidth as fullWidth because ScreenContainer is generally
  // wrapped in styled(ScreenContainer) and that wrapper would not pass the props
  // since it would be identified as transient ($).
  fullWidth?: boolean;
  title: TranslatedString | Array<TranslatedString>;
};

export const ScreenContainer: FC<Props> = ({ title, fullWidth, ...props }) => {
  useEffect(() => {
    const parts = ["Valor"];
    if (isStaging) parts.push("Staging");
    if (Array.isArray(title)) {
      // only push truthy parts
      for (const t of title) {
        if (t) parts.push(t);
      }
    } else {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
      if (title) parts.push(title);
    }
    document.title = parts.join(" - ");
  }, [title]);
  return <Styles $fullWidth={fullWidth} {...props} />;
};
